ParametreTransportValidator.$inject = ['validator'];

export default function ParametreTransportValidator(validator) {
    const instance = new validator();
    instance.ruleFor('idTransport').notEmpty().withMessage('VALIDATION_NOTEMPTY');
    instance.ruleFor('idTypeBenne').notEmpty().withMessage('VALIDATION_NOTEMPTY');

    return instance;
}
